import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";
import { useMemo } from "react";

const DOC_TYPES_BASE = "/DocumentRegister/Types";

const fetchDocTypesAPI = () => API.get(DOC_TYPES_BASE);

const addDocTypeAPI = (data) =>
  API.post(DOC_TYPES_BASE, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateDocTypeAPI = (id, data) =>
  API.patch(`${DOC_TYPES_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const useActiveDocTypes = () => {
  const { data, loading } = baseService.useData();
  const activeData = useMemo(() => data.filter((d) => d.active), [data]);
  return { data: activeData, loading };
};

const baseService = createApplicationService({
  name: "docTypes",
  apiFetchFn: fetchDocTypesAPI,
  apiAddFn: addDocTypeAPI,
  apiUpdateFn: updateDocTypeAPI,
});

const docTypeReducer = baseService.reducer;
const useDocTypes = baseService.useData;
const getDocTypes = baseService.getData;
const addDocType = baseService.addData;
const updateDocType = baseService.updateData;

export {
  docTypeReducer,
  useDocTypes,
  getDocTypes,
  addDocType,
  updateDocType,
  useActiveDocTypes,
};
